"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));
var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));
var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));
var _styles = require("@material-ui/core/styles");
var _Close = _interopRequireDefault(require("@material-ui/icons/Close"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: 1,
      '&:hover $icon': {
        opacity: 1
      },
      '&:hover $iconDisabled': {
        opacity: 1
      },
      marginRight: 4,
      marginLeft: 4
    },
    icon: {
      width: 24,
      height: 24,
      borderRadius: '50%',
      backgroundColor: 'transparent',
      border: "2px solid ".concat(theme.palette.background.border),
      opacity: 0,
      transition: 'opacity 0.3s ease-in-out',
      boxSizing: 'border-box'
    },
    iconHover: {
      width: 24,
      height: 24,
      borderRadius: '50%',
      backgroundColor: 'transparent',
      border: "2px solid ".concat(theme.palette.background.border),
      opacity: 1,
      transition: 'opacity 0.3s ease-in-out',
      boxSizing: 'border-box'
    },
    checkedIcon: {
      width: 24,
      height: 24,
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: theme.palette.background["default"],
      fontSize: 16
    },
    disabled: {},
    iconDisabled: {
      width: 24,
      height: 24,
      borderRadius: '50%',
      backgroundColor: 'transparent',
      border: "2px solid ".concat(theme.palette.background.border),
      fontSize: 16,
      opacity: 0,
      transition: 'opacity 0.3s ease-in-out'
    }
  };
});
var SttCheckboxV2 = function SttCheckboxV2(props) {
  var classes = useStyles();
  var checked = props.checked,
    disabled = props.disabled,
    hover = props.hover,
    botaoDisabled = props.botaoDisabled,
    mensagemTooltip = props.mensagemTooltip;
  var classesHover = !hover ? classes.iconHover : classes.icon;
  var icon = botaoDisabled ? /*#__PURE__*/_react["default"].createElement(_Close["default"], {
    className: classes.iconDisabled
  }) : /*#__PURE__*/_react["default"].createElement("span", {
    className: classesHover
  });
  var checkbox = /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], _extends({
    disableRipple: true,
    classes: {
      root: classes.root,
      disabled: classes.disabled
    },
    icon: icon,
    checkedIcon: /*#__PURE__*/_react["default"].createElement(_CheckCircle["default"], {
      className: classes.checkedIcon
    }),
    checked: checked,
    disabled: disabled
  }, props));
  return botaoDisabled && mensagemTooltip ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    title: mensagemTooltip,
    arrow: true
  }, checkbox) : checkbox;
};
var _default = SttCheckboxV2;
exports["default"] = _default;